export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-5">
            关于黑桃视频
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-500 leading-relaxed">
            <p>
              黑桃视频是一个致力于为影迷提供<strong className="text-foreground-800">高清流畅观影体验</strong>的影视资源聚合平台。
              我们精选整理西瓜视频免费、西瓜视频、丝瓜视频等多家平台的高清全集资源，
              打造一站式的<strong className="text-foreground-800">最新电视剧电影大全</strong>，
              让用户无需在多个平台间切换，即可发现和观看心仪的影视内容。
            </p>
            <p>
              平台每日更新<strong className="text-foreground-800">200+部影片</strong>，
              覆盖电视剧、电影、综艺、动漫、纪录片等多种类型，
              采用智能带宽适配技术实现<strong className="text-foreground-800">不缓冲流畅播放</strong>。
              无论你是追剧党、电影爱好者还是动漫迷，都能在这里找到属于自己的观影天地。
            </p>
            <p>
              黑桃视频始终坚持<strong className="text-foreground-800">免费、高清、不缓冲</strong>的服务理念，
              持续优化播放体验和内容覆盖，努力成为你首选的在线影视观看平台。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            <div className="bg-background-50 rounded-xl p-4 border border-background-200/70">
              <div className="text-2xl font-heading text-primary-500 mb-1">200+</div>
              <p className="text-xs text-foreground-500">每日更新影片</p>
            </div>
            <div className="bg-background-50 rounded-xl p-4 border border-background-200/70">
              <div className="text-2xl font-heading text-accent-500 mb-1">1700+</div>
              <p className="text-xs text-foreground-500">影视资源总量</p>
            </div>
            <div className="bg-background-50 rounded-xl p-4 border border-background-200/70">
              <div className="text-2xl font-heading text-secondary-500 mb-1">13类</div>
              <p className="text-xs text-foreground-500">内容频道分类</p>
            </div>
            <div className="bg-background-50 rounded-xl p-4 border border-background-200/70">
              <div className="text-2xl font-heading text-primary-500 mb-1">4K</div>
              <p className="text-xs text-foreground-500">最高画质支持</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}